import React from "react";
import ContactInfo from "../pages/PIE/ContactInfo/ContactInfo";
import NotFound from "../pages/NotFound";
import RevenueContainer from "../pages/PIE/Revenues/RevenueContainer";
import NewSuiteBreakdown from "../pages/Residential/SuiteBreakdown/NewSuiteBreakdown";
import Summary from "../pages/Summary/Summary";
import Submit from "../pages/Submit/Submit";
import CapitalCostsSummary from "../pages/PIE/CapitalCostsSummary";
import Comment from "../pages/PIE/Comment/Comment";
import Analysis from "../pages/PIE/Analysis/Analysis";
import LeaseInfo from "../pages/Commercial/LeaseInfo/LeaseInfo";
import VacantAskingRate from "../pages/Commercial/VacantAskingRate/VacantAskingRate";
import ParkingPropertySummary from "../pages/Commercial/ParkingPropertySummary/ParkingPropertySummary";
import ExpenseContainer from "../pages/PIE/Expenses/ExpenseContainer";
import ResidentialParking from "../pages/Residential/ResidentialParking/ResidentialParking";
import AssistedLiving from "../pages/Residential/AssistedLiving/AssistedLiving";
import ReserveForReplacementAllowance from "../pages/PIE/ReserveForReplacementAllowance/ReserveForReplacementAllowance";
import IncomeAttributeTable from "../pages/PIE/IncomeAttribute/IncomeAttributeTable";
import CapitalCostContainer from "../pages/PIE/CapitalCost/CapitalCostContainer";
import RoomStatistics from "../pages/PIE/RoomStatistics/RoomStatistics";
import BedCounts from "../pages/PIE/BedCounts/BedCounts";
import Subsidy from "../pages/PIE/Subsidy/Subsidy";
import DirectProductCost from "../pages/PIE/MTL/DirectProductCost";
import FixedCharges from "../pages/PIE/MTL/FixedCharges";
import MotelRevenue from "../pages/PIE/MTL/MotelRevenue";
import UndistributedExpenses from "../pages/PIE/MTL/UndistributedExpenses";
import OccupancyStatistics from "../pages/PIE/OccupancyStatistics/OccupancyStatistics";
import RoundsRate from "../pages/PIE/RoundsRate";
import MemoryCare from "../pages/Residential/MemoryCare/MemoryCare";
import IndependentLiving from "../pages/Residential/IndependentLiving/IndependentLiving";
import NumberOfSites from "../pages/PIE/NumberOfSites/NumberOfSites";
import BusinessOperations from "../pages/BusinessOperations/BusinessOperations";
import IncomeExpense from "../pages/IncomeExpense/IncomeExpense";
import Utilities from "../pages/Residential/Utilities/Utilities";
import { BusinessOperationsProvider } from "./context/BusinessOperationsContext";
import LeaseInfoInternal from "../pages/Commercial/LeaseInfo/LeaseInfoInternal";
import PropertyDetails from "../components/AggregateSite/PropertyDetails/PropertyDetails";
import LicensedLands from "../components/AggregateSite/LicensedLands/LicensedLands";
import LicensedPonds from "../components/AggregateSite/LicensedPonds/LicensedPonds";
import UnlicensedLands from "../components/AggregateSite/UnlicensedLands/UnlicensedLands";
import AggregateFileUpload from "../pages/AggregateFileUpload/AggregateFileUpload";
import AGSSummary from "../pages/Summary/AGSSummary";

const CompiledComponents: Record<string, JSX.Element> = {
  'ContactInfo': <ContactInfo />,
  'IncomeExpense': <IncomeExpense />,
  'Comment': <Comment />,
  'Analysis': <Analysis />,
  'CapitalCostsSummary': <CapitalCostsSummary />,
  'NotFound': <NotFound />,
  'RevenueContainer': <RevenueContainer />,
  'ExpenseContainer': <ExpenseContainer />,
  'ReserveForReplacementAllowance': <ReserveForReplacementAllowance />,
  'CapitalCostContainer': <CapitalCostContainer />,
  'IncomeAttributeTable': <IncomeAttributeTable />,
  'LeaseInfo': <LeaseInfo />,
  'LeaseInfoInternal': <LeaseInfoInternal />,
  'VacantAskingRate': <VacantAskingRate />,
  'ParkingPropertySummary': <ParkingPropertySummary />,
  'AssistedLiving': <AssistedLiving />,
  'ResidentialParking': <ResidentialParking />,
  'SuiteBreakdown': <NewSuiteBreakdown />,
  'Utilities': <Utilities />,
  'RoomStatistics': <RoomStatistics />,
  'OccupancyStatistics': <OccupancyStatistics />,
  'DirectProductCost': <DirectProductCost />,
  'FixedCharges': <FixedCharges />,
  'MotelRevenue': <MotelRevenue />,
  'UndistributedExpenses': <UndistributedExpenses />,
  'RoundsRate': <RoundsRate />,
  'MemoryCare': <MemoryCare />,
  'IndependentLiving': <IndependentLiving />,
  'Summary': <Summary />,
  'Submit': <Submit />,
  'BedCounts': <BedCounts />,
  'Subsidy': <Subsidy />,
  'BusinessOperations': <BusinessOperationsProvider><BusinessOperations /></BusinessOperationsProvider>,
  'NumberOfSites': <NumberOfSites />,
  'AggregateFileUpload': <AggregateFileUpload />,
  'PropertyDetails': <PropertyDetails />,
  'LicensedLands': <LicensedLands />,
  'LicensedPonds': <LicensedPonds />,
  'UnlicensedLands': <UnlicensedLands />,
  'AGSSummary': <AGSSummary />
};

export default CompiledComponents;
